module.exports = __webpack_public_path__ + "img/a6fd71f.jpg";